module.exports = __webpack_public_path__ + "img/logo-skema.9c15dd9f.png";